module.exports = __webpack_public_path__ + "media/illus/book-tourcrib-help-181f091a.png";